<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">
                <div class="list mtb80">
            <div class="ctrl_bar right">
                        <button class="buttn" type="button" @click="goInquire">+ BIM 설계 및 시뮬레이션 의뢰</button>
                    </div>
                    <div class="table">
                        <table>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>프로젝트</th>
                                    <th>프로젝트 등록 날짜</th>
                                    <th>전체 댓글 수</th>
                                    <!--th>안 읽은 댓글 수</th-->
                                </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(project, index) in projects" :key="project.id">
                                <td>{{ pagination.total - ((pagination.current_page - 1) * pagination.per_page) - index }}</td>
                                <td>
                                  <span class="title">
                                    <a href="#" @click.prevent="openProject(project)">
                                      {{ project.projectname }}
                                    </a>
                                  </span>
                                </td>
                                <td>{{ project.timemodified?.substring(0,10) }}</td>
                                <td>{{ project.total_comments }}</td>
                                <!--td>{{ project.unread_comments }}</td-->
                              </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="pagination" v-if="pagination && pagination.last_page > 1">
                          <a
                            href="#"
                            v-if="pagination.current_page > 1"
                            class="prev"
                            @click.prevent="goPage(pagination.current_page - 1)"
                          >
                                <svg id="_레이어_1" data-name="레이어 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.45 12.08">
                                    <path d="M.71,11.37l5.33-5.33L.71.71" fill="none" stroke="#1b1e23" stroke-width="2"/>
                                </svg>
                          </a>

                          <a
                            v-for="page in pagination.last_page"
                            :key="page"
                            href="#"
                            :class="{ active: page === pagination.current_page }"
                            @click.prevent="goPage(page)"
                          >
                            {{ page }}
                          </a>

                          <a
                            href="#"
                            v-if="pagination.current_page < pagination.last_page"
                            class="next"
                            @click.prevent="goPage(pagination.current_page + 1)"
                          >
                                <svg id="_레이어_1" data-name="레이어 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.45 12.08">
                                    <path d="M.71,11.37l5.33-5.33L.71.71" fill="none" stroke="#1b1e23" stroke-width="2"/>
                                </svg>
                          </a>
                    </div>
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>

<script>
    import TheHeader from '@/components/TheHeader.vue'   
    import TheFooter from '@/components/TheFooter.vue'
    import api from '@/api'

    export default {
        name: 'DesignSimulation',
        components: {   
            TheHeader,
            TheFooter
        },
        data() {    
          return {
            projects: [],
            pagination: null,
            isLoggedIn: false,
            user: null
          }
        },
        async mounted() {
          await this.checkAuth();
          //if (this.isLoggedIn) {
            this.fetchProjects();
          //}
        },
        methods: {
            async openProject(project) {
                try {
                  const res = await api.post('/admin/api_project_permission', {
                    projectno: project.projectno
                  }, { withCredentials: true });

                  if (res.data.allowed) {
                    this.$router.push({
                      path: '/design_simulation_view',
                      query: { projectno: project.projectno }
                    });
                  }
                } catch (e) {
                  alert('해당 프로젝트 열람 권한이 없습니다');
                }
              },
            async checkAuth() {
                /*
                try {
                  const res = await api.get('/admin/auth_check', { withCredentials: true });
                  if (res.data.logged_in) {
                    this.isLoggedIn = true;
                    this.user = res.data.user;
                  } else {
                        // 로그인 안 된 경우
                        const referer = window.location.pathname + window.location.search;
                        window.location.href = `/login_form?referer=${encodeURIComponent(referer)}`;
                  }
                } catch (e) {
                  this.isLoggedIn = false;
                }
                */
              },

              async fetchProjects() {
                try {
                  const res = await api.get('/admin/api_projects', {
                    params: this.$route.query
                  });
                  this.projects = res.data.data;
                  this.pagination = res.data;
                } catch (e) {
                  console.error(e);
                }
              },

              goPage(page) {
                if (!page || page < 1 || page > this.pagination.last_page) return;

                this.$router.push({
                  path: this.$route.path,
                  query: {
                    ...this.$route.query,
                    page
                  }
                });

                this.fetchProjects();
              },
          goInquire() {
                this.$router.push({
                      path: '/inquire_form',    
                      query: { type: 3 }
                });
          }
       }
    }
</script>